import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@fluentui/react';
import { useFeaturePanel } from '../../feature/FeaturePanel/useFeaturePanel';
import { useAuth } from '@msrceng/auth';
/**
 * Hook to generate the "Preview" toggle menu item that opens the
 * feature flag panel.
 */
export const usePreviewToggle = ({ stringsPreviewItem: { text = 'Preview', titlePreview = 'Preview new features', titlePreviewSignedOut = 'Sign in to preview new features', } = {}, }) => {
    const { isFeaturePanelOpen, setIsFeaturePanelOpen } = useFeaturePanel();
    const { isApiTokenLoaded } = useAuth();
    const title = isApiTokenLoaded ? titlePreview : titlePreviewSignedOut;
    return {
        key: 'previewToggle',
        text,
        disabled: !isApiTokenLoaded,
        title,
        iconProps: { iconName: 'TestCase' },
        secondaryText: isApiTokenLoaded
            ? undefined
            : (_jsx(Icon, { iconName: 'Lock', role: 'presentation' })),
        checked: isFeaturePanelOpen,
        onClick: () => {
            setIsFeaturePanelOpen(o => !o);
        },
    };
};
